import { render, staticRenderFns } from "./PasswordForget.vue?vue&type=template&id=202e6894&"
import script from "./PasswordForget.vue?vue&type=script&lang=js&"
export * from "./PasswordForget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports